import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOperationSafe } from 'selectors';
import { IState } from 'services/root-reducer';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { LoginForm } from 'scenes/overlay-login/login-form';
import { PanelHeader, CloseButton, PanelBody } from 'components';
import { useTranslation } from 'react-i18next';

export const MobileUIAuthForm = () => {
    let loginOverlayOperation = useSelector(
        (state: IState) => getOperationSafe(state, 'LOGIN_OVERLAY')
    );
    const { t } = useTranslation();

    if (!loginOverlayOperation.data?.visible) {
        return null;
    }

    return (
        <SlideUpPanel
            open
            fullscreen
            className='mobile-ui-auth-form fix-close-button'
        >
            <PanelHeader>
                <div className="header-text">
                    {t('Авторизация')}
                </div>
                <CloseButton
                    onClick={() => {
                        overlayWindowsActions.hideLoginOverlay();
                    }}
                />
            </PanelHeader>

            <PanelBody>
                <LoginForm />
            </PanelBody>
        </SlideUpPanel>
    );
};
